import { Plus } from "lucide-react";
import { Link } from "react-router-dom";

import { useUser } from "../../../../hooks/query";
import { useEffect, useState } from "react";
import { DataGrid, Breadcrumb } from "../../../../components";

import { columnDef } from "./column-def";

import { Button } from "../../../../shared";
import { Divider, Box } from "@mui/joy";

export default function List() {
    const { useList } = useUser();
    const listUserSvc = useList();

    const [users, setUsers] = useState([]);

    const fetchUserData = async () => {
        try {
            const response = await listUserSvc.mutateAsync({});
            setUsers(response);
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        fetchUserData();
    }, []);

    return (
        <Box flex={1} display={"flex"} flexDirection={"column"}>
            <Breadcrumb />
            <Divider />
            <Box flex={1}>
                <DataGrid
                    gridData={users}
                    autoHeight={true}
                    columnDefs={columnDef}
                    customToolbarActions={
                        <Button
                            variant="soft"
                            size="md"
                            startDecorator={<Plus size={18} />}
                            component={Link}
                            to={"/admin/users/new"}
                        >
                            New User
                        </Button>
                    }
                />
            </Box>
        </Box>
    );
}
